import { FC } from "react";
import useList from "./hook";
import { Styles } from "./styled";
import AppList from "@lhd/components/CloneApp/pages/AppList";
import SearchAreaBox from "@lhd/components/SearchAreaBox";
import { APP_TYPES } from "@lhd/components/CloneApp/constants";

const ListLayout = (props: ReturnType<typeof useList>) => {
  const {
    statusFilterSelected,
    setStatusFilterSelected,
    categoryFilterSelected,
    setCategoryFilterSelected,
    handleChangeStatus,
    handleChangeCategory,
    statusOptions,
    categoryOptions,
    closeSignal,
    canEditCatalog,
  } = props;

  return (
    <Styles>
      <SearchAreaBox
        tableName={APP_TYPES.COMPANY_POLICIES}
        screen={APP_TYPES.COMPANY_POLICIES}
        nonEditable
        fieldStatus="ステータス"
        fieldCategory="カテゴリー"
        statusFilterSelected={statusFilterSelected}
        handleChangeStatus={handleChangeStatus}
        categoryFilterSelected={categoryFilterSelected}
        handleChangeCategory={handleChangeCategory}
        textStatusField="ステータス"
        textCategoryField="カテゴリー"
        optionDefaultStatus={statusOptions}
        optionDefaultCategory={categoryOptions}
        setStatusFilterSelected={setStatusFilterSelected}
        setCategoryFilterSelected={setCategoryFilterSelected}
        disabledButtonEdit={!canEditCatalog}
        showConfigControls={true}
        forceCheckAllIfEmpty
        categoryStatusParams={{ is_hidden: false, sort_direction: "asc" }}
      />
      <AppList
        quickButtonDirection="vertical"
        {...props}
        forceCloseQuickViewSignal={closeSignal}
      />
    </Styles>
  );
};

const List: FC = () => <ListLayout {...useList()} />;

export default List;
